module.exports = __webpack_public_path__ + "img/jpjqsvg.1e350b88.svg";